/**
+ * JSON Schema for feeds query object.
+ *
+ * http://json-schema.org/
+ */
export default {
  id: "SectionName",
  type: "object",
  properties: {
    sectionName: {
      type: "string",
      required: true
    }
  }
};
